/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon20Solid = forwardRef('People1MinusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.168 6.168a4.167 4.167 0 1 1-8.335 0 4.167 4.167 0 0 1 8.335 0Z" }),
        React.createElement("path", { d: "M2.173 16.369C3.113 12.289 7.638 12 10 12c1.19 0 2.928.073 4.481.668.195.074.137.332-.072.332H13a3 3 0 0 0-2.509 4.646c.095.144-.002.354-.175.354H3.641c-.906 0-1.671-.748-1.468-1.631Z" }),
        React.createElement("path", { d: "M13 15a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" })));
});
